import { PersonDto } from '../services/api';

export const mergePersonForCanvasUpdate = (previousPerson: PersonDto | null | undefined, updatedPerson: PersonDto): PersonDto => {
  if (!previousPerson) {
    return updatedPerson;
  }

  return {
    ...previousPerson,
    ...updatedPerson,
    canEdit: typeof updatedPerson.canEdit === 'boolean' ? updatedPerson.canEdit : previousPerson.canEdit,
    canDelete: typeof updatedPerson.canDelete === 'boolean' ? updatedPerson.canDelete : previousPerson.canDelete,
  };
};
